<div
  *ngIf="!fieldAttribute.hidden"
  [attr.data-test-id]="'wrap-' + fieldAttribute.elementDataTestId"
  [ngClass]="fieldAttribute.elementStyles.containerStyle"
  class="multiple-select-container"
>
  <label
    *ngIf="fieldAttribute.backendAttribute.label"
    class="form-label"
    [for]="fieldAttribute.id"
    [ngClass]="fieldAttribute.elementStyles.labelStyle"
  >
    {{ fieldAttribute.backendAttribute.label | translate }}
    <span *ngIf="fieldAttribute.backendAttribute.required">*</span>
  </label>
  <div
    [class.is-invalid]="isFieldInvalid()"
    [class.pe-5]="isFieldInvalid()"
    [class.disabled-control]="fieldAttribute.disabled"
    [ngClass]="fieldAttribute.elementStyles.contentStyle"
    [class.fixed-height]="fieldAttribute.backendAttribute.scheme_name !== SearchFormTypes.MAP_SEARCH_BLOCK"
    [attr.data-test-id]="'container_' + fieldAttribute.elementDataTestId"
    class="d-flex flex-row flex-wrap"
  >
    <span class="btn btn-outline-secondary btn-sm selected" *ngFor="let item of selectedItems; index as i">
      {{ item.title | translate }}
      <span
        [attr.data-test-id]="fieldAttribute.elementDataTestId + '-item-' + i"
        class="close-selected"
        (click)="onCloseItem(item)"
      >
        <b>x</b>
      </span>
    </span>
    <input
      appToggleOverflow
      [hasSizeLimit]="true"
      class="multiple-search-input"
      [class.disabled-control]="fieldAttribute.disabled"
      [class.mt-1]="selectedItems.length > 0"
      type="text"
      #multipleSearchInput
      #typehead="ngbTypeahead"
      multiple
      container="body"
      [attr.data-test-id]="fieldAttribute.elementDataTestId"
      [id]="fieldAttribute.id"
      [placeholder]="fieldAttribute.backendAttribute.placeholder | translate"
      [ngbTypeahead]="search"
      [inputFormatter]="formatter"
      [resultFormatter]="formatter"
      (selectItem)="onSelectItem($event)"
      (focus)="focus$.next($event.target.value)"
      (click)="click$.next($event.target.value)"
      (blur)="checkErrors()"
    />
  </div>
  <small
    *ngIf="form.get(fieldAttribute.backendAttribute.name) && form.get(fieldAttribute.backendAttribute.name).invalid"
    class="d-flex mt-1 invalid-feedback"
    [attr.data-test-id]="fieldAttribute.errorDataTestId"
  >
    {{ getValidationError(form.get(fieldAttribute.backendAttribute.name)) | translate }}
  </small>
</div>
